// extracted by mini-css-extract-plugin
export var cronos = "CronosPro, Helvetica, Arial, sans-serif";
export var fullWidth = "index-module--fullWidth--jvj2O util-module--fullWidth--iiqEb";
export var intro = "index-module--intro--utZlc index-module--fullWidth--jvj2O util-module--fullWidth--iiqEb";
export var layout = "index-module--layout--RN5az global-module--global--PAs-2";
export var layoutDebug = "index-module--layoutDebug--e-JB+ index-module--layout--RN5az global-module--global--PAs-2";
export var maxWidth = "1250px";
export var mobilePadding = "4vw";
export var mqMinMd = "screen and (min-width: 48em)";
export var mqMinXl = "screen and (min-width: 75em)";
export var mqMinXxl = "screen and (min-width: 119.938em)";